module.exports = {
      id: "biggan-chinta-usage",
      viewBox: "0 0 156 40",
      url: "/" + "svg-sprite-475344759687326ca60b708b4aa20d33.svg#biggan-chinta",
      toString: function () {
        return this.url;
      }
    }